var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotesBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icono / Outlined / Magazine") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,18.9272 C19.677,18.8192 19.006,18.6072 18.434,18.4262 C17.801,18.2252 17.083,17.9992 16,17.9992 C14.793,17.9992 13.787,18.4342 13,19.0152 L13,4.9652 C13.623,4.5512 14.696,4.0002 16,4.0002 C16.466,4.0002 16.705,4.0752 17.228,4.2402 C18.012,4.4892 19.021,4.8072 21,4.9392 L21,18.9272 Z M8,17.9992 C6.917,17.9992 6.199,18.2252 5.566,18.4262 C4.994,18.6072 4.323,18.8192 3,18.9272 L3,4.9392 C4.979,4.8072 5.988,4.4892 6.772,4.2402 C7.295,4.0752 7.534,4.0002 8,4.0002 C9.307,4.0002 10.379,4.5502 11,4.9642 L11,19.0152 C10.213,18.4342 9.207,17.9992 8,17.9992 L8,17.9992 Z M16,2.0002 C14.259,2.0002 12.872,2.6702 12,3.2362 C11.128,2.6702 9.741,2.0002 8,2.0002 C6.14,2.0002 6.01,2.8652 1.976,2.9862 C1.437,3.0022 1,3.4442 1,3.9842 L1,19.9812 C1,20.5462 1.477,21.0012 2.041,20.9832 C6.012,20.8542 6.149,19.9982 8,19.9982 C10,19.9982 11,22.0002 11,22.0002 L13,22.0002 C13,22.0002 14,19.9982 16,19.9982 C17.851,19.9982 17.988,20.8542 21.959,20.9832 C22.523,21.0012 23,20.5462 23,19.9812 L23,3.9842 C23,3.4442 22.563,3.0022 22.024,2.9862 C17.99,2.8652 17.86,2.0002 16,2.0002 L16,2.0002 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icono-/-Outlined-/-Magazine",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u2731-/-Color-/-Black-/-800",
    mask: "url(#mask-2)",
    fill: "#444444"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-13",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesBlack);
export default __webpack_public_path__ + "static/media/notes-black.a514aaf72566a5c0c5ca2be2eff5562d.svg";
export { ForwardRef as ReactComponent };